import { CaseRunClient, LabReportsTextsType } from '@app/api2/api';
import * as React from 'react';
import { Form, Tab, TextArea } from 'semantic-ui-react';
import { BPBoxWithHeader } from '@common/BPBoxWithHeader';
import { BPTabPane } from '@common/BPTabPane';

interface INoteTemplatesProps {
    labId: number,
    caseId: number,
    caseRunId: number,
    reportType: LabReportsTextsType;
    textOnly?: boolean;
}

export const NoteTemplates: React.FunctionComponent<INoteTemplatesProps> = (props) => {
    const client = new CaseRunClient()
    const [templates, setTemplates] = React.useState<{ title: string, content: string }[]>([])

    React.useEffect(() => {
        async function fetch() {
            const res = await client.reportTexts(props.labId, props.caseId, props.caseRunId, props.reportType)
            setTemplates(Object.keys(res).map(m => { return { title: window.translation.likelihoodType[m], content: res[m] } }))
        }

        fetch()
    }, [])

    if (props.textOnly)
        return <pre>{templates.map(m => m.content).join("")}</pre>

    return templates.length ? <BPBoxWithHeader header={window.translation.reportTexts.reportTexts}>
        <Tab menu={{ secondary: true, pointing: true }} panes={templates.map(m => {
            return { menuItem: m.title, render: () => <BPTabPane><Form><TextArea rows={10} value={m.content}></TextArea></Form></BPTabPane> }
        })}></Tab>
    </BPBoxWithHeader> : null;
};
